import { ExternalLink } from '@ui-components/actions/ExternalLink'
import { ReactNode } from 'react'
import { useIntl } from 'react-intl'

export const DataProcessingLink = (msg: ReactNode[]) => {
  const intl = useIntl()
  return (
    <ExternalLink
      key={'data-processing-link'}
      href={intl.formatMessage({ id: 'common-bank-data-processing-link-url' })}
    >
      {msg}
    </ExternalLink>
  )
}
